// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getActiveVouchersListApi} from "../../Service/Api/ActiveVouchersListApi"
import { getActiveVouchersList,getErrors } from "../Reducer/ActiveVouchersListReducer"


 

// Watchers
function* activeVouchersListSaga() {
	yield takeEvery("activevouchers_list/getActiveVouchers", getAllActiveVouchers)
}

// Sagas
function* getAllActiveVouchers(action) {

	try {
		const getVouchersData = yield call(getActiveVouchersListApi, action.payload)
		// console.log(getCustomerVouchersApply.status);
		if (getVouchersData.request.status === 200) {
			yield put(getActiveVouchersList(getVouchersData))
			// console.log(getCustomerVouchersApply.status);
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(activeVouchersListSaga)])
}
